export default __webpack_public_path__ + "static/media/teo.a7d284ea.jpeg";